export default __webpack_public_path__ + "static/media/7077ROUGE.608f8f0d.pdf";